import React, { useState } from 'react';

import { Box, Card, Grid } from '@mui/material';

import SocialNetworkFieldCompany from 'components/SocialNetworkFieldCompany';
import Text from 'components/Text';
import { useCompanySocialNetworks } from 'pages/CompanyData/hooks/useCompanySocialNetworks';

interface SocialNetwork {
  type: string;
  username: string;
}

interface CompanySocialNetworkFieldProps {
  networkTypes: string[];
  companyUuid: string;
  onSave?: (networks: SocialNetwork[]) => void;
}

const formatType = (type: string) => type.charAt(0).toUpperCase() + type.slice(1).toLowerCase();

const CompanySocialNetworkField: React.FC<CompanySocialNetworkFieldProps> = ({
  networkTypes,
  companyUuid,
  onSave,
}) => {
  const { socialNetworks, upsertSocialNetwork, loading, error } =
    useCompanySocialNetworks(companyUuid);

  const [networks, setNetworks] = useState<SocialNetwork[]>([]);

  const handleSocialNetworkChange = async (type: string, value: string) => {
    await upsertSocialNetwork({
      social_network_type: type,
      social_network_username: value,
    });
  };

  const handleNetworkChange = (type: string, username: string) => {
    const updatedNetworks = [...networks];
    const existingIndex = updatedNetworks.findIndex(n => n.type === type);

    if (existingIndex >= 0) {
      updatedNetworks[existingIndex] = { type, username };
    } else {
      updatedNetworks.push({ type, username });
    }

    setNetworks(updatedNetworks);
    onSave?.(updatedNetworks);
  };

  return (
    <Box>
      <Grid container spacing={2}>
        {networkTypes.map((type: string) => (
          <Grid item xs={12} sm={6} key={type}>
            <Card sx={{ borderRadius: 2 }}>
              <Text color="textPrimary" bold>{`Perfil da empresa no ${formatType(type)}`}</Text>
              <Box display="flex" flexDirection="row" alignItems="center" gap={1}>
                <Text
                  color="textPrimary"
                  opacity={0.8}
                >{`www.${formatType(type).toLowerCase()}.com/`}</Text>
                <SocialNetworkFieldCompany
                  companyUuid={companyUuid}
                  socialNetworkType={type}
                  placeholder={formatType(type)}
                  onChange={value => handleNetworkChange(type, value)}
                />
              </Box>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default CompanySocialNetworkField;
